















































import { ItemDetailsTemplate } from '@/interfaces/item-details-template.inteface';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { TemplatesState } from '@/store/item-details-templates.store';
import { namespace } from 'vuex-class';
import { isEmptyObject } from '@/helpers/helpers';
import store from '@/store/store';
import { User } from '@/interfaces/user.interface';
import PermissionsService from '@/services/permissions.service';

const templatesModule = namespace('templates');

@Component
export default class ItemDetailsTemplateDialog extends Vue {
  @Prop() items!: ItemDetailsTemplate[];
  @Prop() itemDetails: string;
  @templatesModule.State itemDetailsTemplatesDialogVisible!: boolean;

  @templatesModule.Action createTemplate: any;
  @templatesModule.Action updateTemplate: any;
  @templatesModule.Action openItemDetailsTemplateialog: any;
  @templatesModule.Action closeItemDetailsTemplateDialog: any;

  isGlobal: boolean = false;

  newTemplateName: string = '';
  updatedTemplate: ItemDetailsTemplate = {};
  selectedTemplate: string | ItemDetailsTemplate = '';

  COMBO_BOX_REF_NAME: string = 'combobox';

  // TODO: Commented out for now as seems that autocomplete has been fixed with Vuetify v2?
  // mounted() {
  //   this.fixVuetifyAutocompleteBug();
  // }

  get canSetGlobalTemplates(): boolean {
    return PermissionsService.can('global_item_details_templates', 'create');
  }

  get filteredItems(): ItemDetailsTemplate[] {
    return this.canSetGlobalTemplates ? this.items : this.items.filter(template => template.isGlobal === false);
  }

  get templateSaveDialog(): boolean {
    return this.itemDetailsTemplatesDialogVisible;
  }

  set templateSaveDialog(value: boolean) {
    value && this.openItemDetailsTemplateialog() || this.closeItemDetailsTemplateDialog();
  }

  setNewTemplate(selectedTemplate: string | ItemDetailsTemplate = '') {
    // strong type checking to avoid unwanted types
    if (this.isItemDetailsTemplate(selectedTemplate)) {
      this.updatedTemplate = selectedTemplate;
      this.isGlobal = this.updatedTemplate.isGlobal ? true : false;
      this.newTemplateName = '';
    } else if (typeof selectedTemplate === 'string') {
      this.updatedTemplate = {};
      this.newTemplateName = selectedTemplate;
    }
  }

  isItemDetailsTemplate(selectedTemplate: string | ItemDetailsTemplate): selectedTemplate is ItemDetailsTemplate {
    return (selectedTemplate as ItemDetailsTemplate).uuid !== undefined;
  }

  get canSaveTemplate(): boolean {
    return this.newTemplateName !== '' ? true : this.canModifyTemplate;
  }

  get canModifyTemplate(): boolean {
    if (!this.updatedTemplateExists) return false;
    if (!this.updatedTemplate.isGlobal) return true;
    return !!this.canSetGlobalTemplates;
  }

  get updatedTemplateExists(): boolean {
    return !isEmptyObject(this.updatedTemplate);
  }

  saveItemDetailsTemplate() {
      if (this.updatedTemplateExists) return this.updateSelectedTemplate();
      return this.createNewTemplate();
  }
  
  createNewTemplate() {
    const user: User = store.getters['users/currentUser'];
    const createdBy = user.uuid;
    this.createTemplate({
      itemDetailsTemplate: {
        itemDetails: this.itemDetails,
        name: this.newTemplateName,
        createdBy,
        isGlobal: this.isGlobal,
      },
      successAction: 'closeItemDetailsTemplateDialog'
    })
  }

  updateSelectedTemplate() {
    this.updatedTemplate.itemDetails = this.itemDetails;
    this.updatedTemplate.updatedAt = new Date();
    this.updatedTemplate.isGlobal = this.isGlobal;
    this.updateTemplate({
      itemDetailsTemplate: this.updatedTemplate,
      successAction: 'closeItemDetailsTemplateDialog'
    })
  }

  closeDialog() {
    this.closeItemDetailsTemplateDialog();
    this.clearSelectedTemplate();
  }

  clearSelectedTemplate() {
    this.selectedTemplate = '';
  }

  // TODO: Commented out for now as seems that autocomplete has been fixed with Vuetify v2?
  // private fixVuetifyAutocompleteBug() {
  //   const componentElement: Vue = this.$refs[this.COMBO_BOX_REF_NAME] as Vue;
  //   const inputElement = componentElement.$el.querySelector('input');
  //   inputElement && inputElement.setAttribute('autocomplete', 'chrome-off');
  // }
}
